import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import axios from "../../API/axios";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import moment from "moment";
import PreviewSharpIcon from "@mui/icons-material/PreviewSharp";
import { Modal, Col, Form } from "react-bootstrap";
import HiringStatus from "./HiringStatus";
import defaultImage from "../../../src/assets/images/Default_user_image.png";
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import ThumbDownAltSharpIcon from "@mui/icons-material/ThumbDownAltSharp";
import DoneAllSharpIcon from "@mui/icons-material/DoneAllSharp";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import ClearSharpIcon from "@mui/icons-material/ClearSharp";
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";
import Tooltip from "@mui/material/Tooltip";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import VerticalAlignBottomSharpIcon from "@mui/icons-material/VerticalAlignBottomSharp";
import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp';
import SearchIcon from "@mui/icons-material/Search";
import toast from "react-hot-toast";
import { format } from "date-fns";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";



const InterviewSchedule = () => {
  const sessionId = localStorage.getItem("sessionId");
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [interviewData, setInterviewData] = useState("");

  // User Info modal state
  const [showUserInfo, setUserInfo] = useState(false);
  const handleShowInfo = () => setUserInfo(true);
  const handleCloseInfo = () => setUserInfo(false);

  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const handleShowRemark = () => setShowRemarkModal(true);
  const handleCloseRemark = () => setShowRemarkModal(false);

  const [jobAppId, setjobAppId] = useState(0);
  const [jobAppInfoData, setJobAppInfoData] = useState([]);
  const [displays, setDisplays] = useState(false);

  const getInterviewShedule = async (page) => {
    try {
      const requestBody = {
        sessionId: sessionId,
        pageNumber: page,
        pageSize: 10,
      };
      const response = await axios.post(
        "JobApplication/GetAllInterviews",
        requestBody
      );
      console.log("response=====>", response);

      setInterviewData(response.data.responseData.allJobInterviews);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    getInterviewShedule(currentPage);
  }, [currentPage]);

  const handleClose = () => {
    setShowAcceptModal(false);
  };

  const getJobAppInfo = async () => {
    try {
      const requestBody = {
        sessionId: sessionId,
        jbApplctnId: jobAppId,
      };
      const response = await axios.post("/JobApplication/GetInfo", requestBody);
      setJobAppInfoData(response.data.responseData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  // useEffect(() => {
  //   getJobAppInfo();
  // }, [jobAppId]);

  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const [candidateList, setCandidateList] = useState([]);

  // Handlers to open and close the modal
  const handleShowModal = () => setShowAppliedModal(true);
  const handleCloseModal = () => setShowAppliedModal(false);
  //   const [showInstModal, setShowInstModal] = useState(false);

  console.log("candidateList", candidateList);
  const handleCancel = () => {
    setShowConfirmationModal(false);
  };

  const [showInstModal, setShowInstModal] = useState(false);
  const handleInstModal = () => setShowInstModal(true);
  const handleCloseInstModal = () => setShowInstModal(false);

  const [showInstConfirmationModal, setShowInstConfirmationModal] =
    useState(false);
  const handleInstShowModal = () => setShowInstConfirmationModal(true);
  const handleInstituteCancel = () => setShowInstConfirmationModal(false);

  const [search, setSearch] = useState("");
  const [InsCandidateList, setInsCandidateList] = useState([]);
  const [instituteId, setInstituteId] = useState("");
  console.log("InsCandidateList", InsCandidateList);


  const AcceptApplication = async (id, hiringStatus) => {
    console.log("hiringStatus", id, hiringStatus);

    try {
      const requestBody = {
        sessionId: sessionId,
        jbApplctnId: id,
        hiringStatus: hiringStatus,
        remark: "",
      };
      console.log("AcceptApplication Request:", requestBody);
      const response = await axios.post(
        "/JobApplication/UpdateHiringStatus",
        requestBody
      );
      console.log("AcceptApplication Response:", response);
      setShowConfirmationModal(false);
      toast.success(response.data.message);
      //   JobAppGetAll();
      getInterviewShedule();
    } catch (error) {
      toast.error("Some problem occurred!");
      console.error("API Error:", error);
    }
  };


  const getGetAllCandidate = (page) => {
    const data = {
      pageNumber: page,
      pageSize: 10,
    };
    axios
      .post(
        `/Candidate/GetAllByInstt/${instituteId}?Type=${"All"}&TypeId=${0}&Search=${search}`,
        data
      )
      .then((response) => {
        const res = response.data.responseData.items;
        console.log("res====>", res);
        setInsCandidateList(res);
        // setDisplay(false);
      })
      .catch((e) => {
        console.error("Error fetching candidates:", e);
        if (e.response && e.response.status === 404) {
          //   setDisplay(true);
        }
      });
  };

  useEffect(() => {
    if (instituteId || search) {
      getGetAllCandidate();
    }
  }, [instituteId, search]);

  let inst = "Institution";

  const [scheduleTime, setScheduleTime] = useState("");
  const [placeType, setPlaceType] = useState(0);
  const [placeDetails, setPlaceDetails] = useState("");
  const [remark, setRemark] = useState("");

  const JobAppGetAll = async () => {
    try {
      const requestBody = {
        sessionId: sessionId,
        pageNumber: 1,
        pageSize: 10,
      };
      console.log("requestBody", requestBody);
      const response = await axios.post("/JobApplication/GetAll", requestBody);

      // console.log("API Response:", response.data.responseData.jobApplications);
      setCandidateList(response.data.responseData.jobApplications);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    JobAppGetAll();
  }, []);

  const remarkUpdateFn = async () => {
    // console.log("id", id);

    try {
      const requestBody = {
        sessionId: sessionId,
        jbApplctnId: jobAppId,
        remark: updateRemark,
      };
      console.log("requestBody", requestBody);
      const response = await axios.post(
        "/JobApplication/UpdateInterviewRemarks",
        requestBody
      );

      console.log("API Response:", response.data.message);
      const data= response.data.message
      toast.success(data)
      handleCloseRemark();
      setUpdateRemark("");
      setCandidateList(response.data.responseData.jobApplications);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const ScheduleInterview = async () => {
    try {
      const requestBody = {
        sessionId: sessionId,
        jbApplctnId: jobAppId,
        scheduleTime,
        placeType: parseInt(placeType, 10), // Ensure it's a number
        placeDetails,
        remark,
      };
      // console.log("ScheduleInterview", requestBody);

      const response = await axios.post(
        "/JobApplication/ScheduleInterview",
        requestBody
      );

      console.log("getScheduleInterview", response);
      // toast.success(response.data.message)
      toast.success("Interview Scheduled Successfully!");
      JobAppGetAll();
      handleCloseModal(); // Close modal on success
      setScheduleTime("");
      setPlaceType(null);
      setPlaceDetails("");
      setRemark("");
    } catch (error) {
      toast.error("Some problem occurred!");
      console.error("API Error:", error);
    }
  };

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState("");

  //   console.log("acceptApplication", acceptApplication);
  const [instituteAppData, setInstituteAppData] = useState("");

  const [hiringStatuses, setHiringStatuses] = useState({});
  const [hiringStatusvalue, setHiringStatusvalue] = useState({});

  const InstituteCandidateHiringStatus = async (row) => {
    console.log("function working");

    try {
      const updatedStatuses = { ...hiringStatuses }; // Copy existing statuses
      const updatedStatuses1 = { ...hiringStatusvalue }; // Copy existing statuses

      // Iterate over all candidates in the modal's candidate list
      for (const candidate of InsCandidateList) {
        const requestBody = {
          sessionId: sessionId,
          jbApplctnId: row.jbApplctnId,
          insttUid: row.userUid,
          cnddtID: candidate.cnddtId,
          grpTypName: row.grpTypName,
          grpTypeId: row.grpTypeId,
        };
        console.log("function", requestBody, row);

        const response = await axios.post(
          "/JobApplication/GetInstituteCandidateHiringStatus",
          requestBody
        );
        console.log("function api working");
        // Store the hiring status in the state mapped by candidate ID
        updatedStatuses[candidate.cnddtId] =
          response.data.responseData.hiringStatusName;
        updatedStatuses1[candidate.cnddtId] =
          response.data.responseData.hiringStatus;
      }

      setHiringStatuses(updatedStatuses); // Update the state with new statuses
      setHiringStatusvalue(updatedStatuses1); // Update the state with new statuses
    } catch (error) {
      console.error("Error fetching hiring statuses:", error);
    }

    //   sethiringStatusIns(statuses);
    // } catch (error) {
    //   console.error("API Error:", error);
    // }
  };

  const AcceptApplicationAsInst = async (cnddtId) => {
    try {
      const requestBody = {
        sessionId: sessionId,
        jbApplctnId: instituteAppData.jbApplctnId,
        // hiringStatus: ,
        remark: "",
        insttUid: instituteAppData.userUid,
        cnddtID: cnddtId,
        grpTypName: instituteAppData.grpTypName,
        grpTypeId: instituteAppData.grpTypeId,
      };
      console.log("AcceptApplication", requestBody);

      const response = await axios.post(
        "/JobApplication/UpdateHiringStatusForInstituteCandidates",
        requestBody
      );

      console.log("getAcceptApplication", response);
      toast.success(response.data.message);
      JobAppGetAll();
      InstituteCandidateHiringStatus(instituteAppData);
    } catch (error) {
      toast.error(error.response);
      console.error("API Error:", error);
    }
  };
  //   const [candidateId, setCandidateId] = useState("");

  const ScheduleInterviewAsInst = async () => {
    try {
      const requestBody = {
        sessionId: sessionId,
        jbApplctnId: instituteAppData.jbApplctnId,
        scheduleTime,
        placeType: parseInt(placeType, 10),
        placeDetails,
        remark,
        insttUid: instituteAppData.userUid,
        cnddtID: candidateId,
        grpTypName: instituteAppData.grpTypName,
        grpTypeId: instituteAppData.grpTypeId,
      };
      console.log("ScheduleInterview", requestBody);

      const response = await axios.post(
        "/JobApplication/ScheduleInterviewForInstituteCandidates",
        requestBody
      );

      console.log("getScheduleInterview", response);
      // toast.success(response.data.message)
      toast.success("Interview Scheduled Successfully!");
      JobAppGetAll();
      handleCloseModal(); // Close modal on success
      setScheduleTime("");
      setPlaceType(null);
      setPlaceDetails("");
      setRemark("");
      InstituteCandidateHiringStatus(instituteAppData);
    } catch (error) {
      toast.error("Some problem occurred!");
      console.error("API Error:", error);
    }
  };

  // Handlers to open and close the modal
  const [showAppliedModalScheule, setShowAppliedModalScheule] = useState(false);
  const handleShowModalScheule = () => setShowAppliedModal(true);
  const handleCloseModalScheule = () => setShowAppliedModalScheule(false);

  //   Columns
  const columns = [
    {
      name: "APPLIED DATE",
      center: true,
      sortable: true,
      minWidth: "150px",
      //   selector: (row) => row.jbApplctnTypeName,
      cell: (row) => (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="date-box">
              <div className="month">
                {" "}
                {moment(row.appliedTime).format("MMM").toUpperCase()}
              </div>
              <div className="day"> {moment(row.appliedTime).format("DD")}</div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "INTERVIEW DETAILS",
      center: true,
      sortable: true,
      // minWidth: "200px",
      cell: (row) => (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p>{moment(row.scheduleTime).format("DD-MM-YYYY")}</p>
            <p>⏰ 3h:00</p>
          </div>
        </>
      ),
    },
    {
      name: "CANDIDATES",
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          {/* Row for Image and Username */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* User Image */}
            <img
              src={row.userProfilePic}
              alt="User"
              style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            />

            {/* Username */}
            <div
              className="pointer"
              onClick={(e) => {
                e.stopPropagation();
                console.log("Job ID:", row.jobId);
                setUserInfo(true);
                setjobAppId(row.jbApplctnId);
              }}
            >
              {row.userName}
            </div>
          </div>

          {/* Job Tags below Username */}
          <div className="job-footer-left ms-5">
            <ul className="job-tag" style={{ margin: 0, padding: 0 }}>
              <li className="Button-Candidate-jobtag">
                <a href="/SearchJobs">{row.jbApplctnTypeName}</a>
              </li>
            </ul>
          </div>
          <div className="pointer ms-5">
            {moment(row.appliedTime).format("YYYY-MM-DD")}
          </div>
        </div>
      ),
    },
    {
      name: "JOB DETAILS",
      // center: true,
      sortable: true,
      // minWidth: "150px",
      cell: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div className="pointer">{row.jobTitle}</div>
          </div>
          <div className="pointer">{row.shortDescription}</div>
        </div>
      ),
      selector: (row) => row.jobTitle,
    },
    {
      name: "STATUS",
      // center: true,
      sortable: true,
      // minWidth: "150px",
      cell: (row) => (
        <>
          {row.jbApplctnType === 2 ? (
            row.hiringStatus === 9 ? (
              <div className="job-footer-left">
                <ul className="red" style={{ margin: 0, padding: 0 }}>
                  <li>
                    <a href="/SearchJobs">{row.hiringStatusName}</a>
                  </li>
                </ul>
              </div>
            ) : (
              <div className="job-footer-left">
                <ul className="green" style={{ margin: 0, padding: 0 }}>
                  <li>
                    <a href="/SearchJobs">{row.hiringStatusName}</a>
                  </li>
                </ul>
              </div>
            )
          ) : (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              {row.hiringStatus === 1 ? (
                <div className="job-footer-left">
                  <ul style={{ margin: 0, padding: 0 }}>
                    <li>
                      <a href="/SearchJobs">{row.hiringStatusName}</a>
                    </li>
                  </ul>
                </div>
              ) : row.hiringStatus === 5 ? (
                <div className="job-footer-left">
                  <ul className="orange" style={{ margin: 0, padding: 0 }}>
                    <li>
                      <a href="/SearchJobs">{row.hiringStatusName}</a>
                    </li>
                  </ul>
                </div>
              ) : row.hiringStatus === 7 || row.hiringStatus === 8 ? <div className="job-footer-left">
                <ul className="red" style={{ margin: 0, padding: 0 }}>
                  <li>
                    <a href="/SearchJobs">{row.hiringStatusName}</a>
                  </li>
                </ul>
              </div> : (
                <div className="job-footer-left">
                  <ul className="green" style={{ margin: 0, padding: 0 }}>
                    <li>
                      <a href="/SearchJobs">{row.hiringStatusName}</a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </>
      ),
    },
    {
      name: "Action",
      center: true,
      sortable: true,
      minWidth: "150px",
      cell: (row) => (
        <>
          <div className="d-block">
            {row.jbApplctnId === 2 ? (
              <Tooltip title="Candidate List" arrow>
                <PeopleSharpIcon
                  className="pointer"
                  onClick={() => {
                    handleInstModal();
                    setInstituteId(row.userUid);
                    setInstituteAppData(row);
                  }}
                />
              </Tooltip>
            ) : row.hiringStatus === 6 ||
              row.hiringStatus === 8 ||
              row.hiringStatus === 7 ? (
              ""
            ) : (
              <>
                <div className="d-flex mb-2">
                  <span className="me-2">
                    <Tooltip title="Reschedule" arrow>
                      <CalendarMonthSharpIcon
                        className="pointer "
                        onClick={() => {
                          handleShowModal();
                          setjobAppId(row.jbApplctnId);
                        }}
                      />
                    </Tooltip>
                  </span>
                  <span className="me-2 ">
                    <Tooltip title="Update Remark" arrow>
                      {/* <Link to={`/Resume/${row.jbApplctnId}`}> */}
                      <EditIcon
                        className="blueIcon pointer"
                        onClick={() => {
                          handleShowRemark();
                          setjobAppId(row.jbApplctnId);
                        }}
                      />
                      {/* </Link> */}
                    </Tooltip>
                  </span>

                  <span className="me-2">
                    <Tooltip title="Hire" arrow>
                      <DoneIcon
                        className="pointer checkIcon"
                        onClick={() => {
                          setShowConfirmationModal(true);
                          setApplicationStatus("Hired");
                          setjobAppId(row.jbApplctnId);
                          //   AcceptApplication(row.jbApplctnId);
                        }}
                      />
                    </Tooltip>
                  </span>

                </div>
                <span className="me-2">
                  <Tooltip title="Reject" arrow>
                    <ClearSharpIcon
                      className="pointer rejectIcon"
                      onClick={() => {
                        setShowConfirmationModal(true);
                        setApplicationStatus("Rejected");
                        setjobAppId(row.jbApplctnId);
                        // handleCancel();
                        // getUpHiringStatus();
                        // sethiringStatus(row.hiringStatus)
                      }}
                    />
                  </Tooltip>
                </span>
                <span>
                  <Tooltip title="Block" arrow>
                    <BlockSharpIcon
                      className="pointer rejectIcon"
                      onClick={() => {
                        setShowConfirmationModal(true);
                        setApplicationStatus("Blocked");
                        setjobAppId(row.jbApplctnId);
                        //   AcceptApplication(row.jbApplctnId);
                      }}
                    />
                  </Tooltip>
                </span>
                <span className="ms-2 ">
                  <Tooltip title="View Resume" arrow>
                    <Link 
                      target="blank"
                    to={`/Resume?userUID=${row.userUid}`}
                    // to={`/Resume/${row.jbApplctnId}`}
                    >
                      <VisibilitySharpIcon className="ViewIcon" />
                    </Link>
                  </Tooltip>
                </span>

              </>
            )}

          </div>


        </>
      ),
    },
  ];

  const [updateRemark, setUpdateRemark] = useState("");
  const [candidateId, setCandidateId] = useState("");

  //   Institute Columns

  const Inscolumns = [
    {
      name: "CANDIDATES",
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img
              src={row.profileImage}
              alt="User"
              style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            />
            <div className="pointer">{row.firstName}</div>
          </div>

          <div className="pointer ms-5">{row.lastName}</div>
        </div>
      ),
    },
    {
      name: "CLASS NAME",
      // center: true,
      sortable: true,
      // minWidth: "150px",
      cell: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div className="pointer">{row.insttClssName}</div>
          </div>
        </div>
      ),
    },
    {
      name: "BATCH NAME",
      // center: true,
      sortable: true,
      // minWidth: "150px",
      selector: (row) =>
        Array.isArray(row.batchNames)
          ? row.batchNames.join(", ")
          : row.batchNames,
    },
    {
      name: "STATUS",
      sortable: true,
      cell: (row) => (
        <>
          {hiringStatusvalue[row.cnddtId] === 1 ? (
            <div className="job-footer-left">
              <ul style={{ margin: 0, padding: 0 }}>
                <li>
                  <a href="/SearchJobs">{hiringStatuses[row.cnddtId]}</a>
                </li>
              </ul>
            </div>
          ) : hiringStatusvalue[row.cnddtId] === 5 ? (
            <div className="job-footer-left">
              <ul className="orange" style={{ margin: 0, padding: 0 }}>
                <li>
                  <a href="/SearchJobs">{hiringStatuses[row.cnddtId]}</a>
                </li>
              </ul>
            </div>
          ) : (
            <div className="job-footer-left">
              <ul className="green" style={{ margin: 0, padding: 0 }}>
                <li>
                  <a href="/SearchJobs">{hiringStatuses[row.cnddtId]}</a>
                </li>
              </ul>
            </div>
          )}
        </>
      ),
    },
    // {
    //   name: "Action",
    //   center: true,
    //   sortable: true,
    //   minWidth: "150px",
    //   cell: (row) => (
    //     <>
    //       {row.jbApplctnId === "Institution" ? (
    //         <Tooltip title="Candidate List" arrow>
    //           <PeopleSharpIcon
    //             className="pointer"
    //             onClick={() => {
    //               handleInstModal();
    //               setInstituteId(row.userUid);
    //             }}
    //           />
    //         </Tooltip>
    //       ) : (
    //         <div>
    //           <span className="me-2">
    //             <Tooltip title="Schedule" arrow>
    //               <CalendarMonthSharpIcon
    //                 className="pointer"
    //                 onClick={() => {
    //                   handleShowModal();
    //                   setjobAppId(row.jbApplctnId);
    //                 }}
    //               />
    //             </Tooltip>
    //           </span>
    //           <span className="me-2">
    //             <Tooltip title="Accept" arrow>
    //               <DoneAllSharpIcon
    //                 className="pointer"
    //                 onClick={() => {
    //                   //   AcceptApplication(row.jbApplctnId);
    //                   // setjobAppId(row.jbApplctnId);
    //                 }}
    //               />
    //             </Tooltip>
    //           </span>
    //           <span className="me-2">
    //             <Tooltip title="Block" arrow>
    //               <BlockSharpIcon
    //                 className="pointer"
    //                 onClick={() => {
    //                   //   AcceptApplication(row.jbApplctnId);
    //                   // setjobAppId(row.jbApplctnId);
    //                 }}
    //               />
    //             </Tooltip>
    //           </span>
    //           <Tooltip title="Reject" arrow>
    //             <ThumbDownAltSharpIcon
    //               className="pointer"
    //               onClick={() => {
    //                 // handleCancel();
    //                 // getUpHiringStatus();
    //                 // setjobAppId(row.jbApplctnId);
    //                 // sethiringStatus(row.hiringStatus)
    //               }}
    //             />
    //           </Tooltip>

    //           {/* <span className="ms-2 ">
    // 			  <Tooltip title="Download" arrow>
    // 				<Link to={`/Resume/${row.instnCnddtID}`}>
    // 				  <VerticalAlignBottomSharpIcon className="text-dark" />
    // 				</Link>
    // 			  </Tooltip>
    // 			</span> */}
    //         </div>
    //       )}
    //     </>
    //   ),
    // },
    {
      name: "Action",
      center: true,
      sortable: true,
      minWidth: "150px",
      cell: (row) => (
        <>

          {row.hiringStatus === 6 ||
            row.hiringStatus === 8 ||
            row.hiringStatus === 7 ? (
            ""
          ) : (
            <>
              <div>
                <span className="me-2">
                  <Tooltip title="Scheduled" arrow>
                    <CalendarMonthSharpIcon
                      className="pointer"
                      onClick={() => {
                        handleShowModalScheule();
                        setCandidateId(row.cnddtId);
                      }}
                    />
                  </Tooltip>
                </span>
                <span className="me-2">
                  <Tooltip title="Hired" arrow>
                    <DoneIcon
                      className="pointer checkIcon"
                      onClick={() => {
                        handleInstShowModal();
                        setApplicationStatus("Hired");
                        setCandidateId(row.cnddtId);
                        //   AcceptApplication(row.jbApplctnId);
                      }}
                    />
                  </Tooltip>
                </span>
                <span className="me-2">
                  <Tooltip title="Reject" arrow>
                    <ClearSharpIcon
                      className="pointer rejectIcon"
                      onClick={() => {
                        handleInstShowModal();
                        setApplicationStatus("Rejected");
                        setCandidateId(row.cnddtId);
                        // handleCancel();
                        // getUpHiringStatus();
                        // sethiringStatus(row.hiringStatus)
                      }}
                    />
                  </Tooltip>
                </span>
                <span>
                  <Tooltip title="Block" arrow>
                    <BlockSharpIcon
                      className="pointer rejectIcon"
                      onClick={() => {
                        handleInstShowModal();
                        setApplicationStatus("Blocked");
                        setCandidateId(row.cnddtId);
                        //   AcceptApplication(row.jbApplctnId);
                      }}
                    />
                  </Tooltip>
                </span>
              </div>
              <span className="ms-2 ">
                <Tooltip title="Update" arrow>
                  <EditIcon
                    className="blueIcon"
                    onClick={() => {
                      handleShowRemark();
                      setCandidateId(row.cnddtId);
                    }}
                  />
                </Tooltip>
              </span>
            </>
          )}
          <span className="ms-2 ">
            <Tooltip title="Download" arrow>
              <Link to={`/Resume/${row.cnddtId}`}>
                <VerticalAlignBottomSharpIcon className="text-dark" />
              </Link>
            </Tooltip>
          </span>
        </>
      ),
    },
  ];

  return (
    <>
      <section className="pricing-section-three container jobapplication interviews  pt-5">
        <div className="row">
          <div className="mb-1 col-6">
            <h4>
              <span className="orange-box me-2"></span>
              Interviews
            </h4>
          </div>
          <div className="mb-1 col-6 text-start"></div>
        </div>
        <div className="container st3">
          <div className="row">
            <div className="col-lg-12">
              <div className="table-res">
                <div className="react-dataTable">
                  <DataTable
                    noHeader
                    pagination
                    paginationPerPage={7}
                    className="react-dataTable"
                    sortIcon={<ChevronDown size={10} />}
                    paginationDefaultPage={currentPage}
                    onChangePage={(page) => setCurrentPage(page)}
                    columns={columns}
                    data={interviewData}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row">
            <div className="">
              <div className="interview-schedule">
                <table>
                  <thead>
                    <tr>
                      <th>Applied Date</th>
                      <th>Interviews Details</th>
                      <th>Candidates</th>
                      <th>Job Details</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {interviews.map((interview, index) => (
                      <tr key={index}>
                        <td className="date-cell">
                          <div className="date-box">
                            <div className="month">{interview.month}</div>
                            <div className="day">{interview.date}</div>
                          </div>
                        </td>
                        <td className="details-cell ">
                          <h3>{interview.role}</h3>
                          <p>
                            Meeting with: <strong>{interview.company}</strong>
                          </p>
                          <p>⏰ 3h:00 | ⌛ {interview.duration}</p>
                        </td>
                        <td className="actions-cell d-flex">
                          <div className="d-flex align-center">
                            <span class="icon-map-pin me-3 icons f-18"></span>
                          </div>
                          <div className="d-flex align-center">
                            <span class="icon-calendar me-3 icons f-18"></span>
                          </div>
                          <button className="cancel-btn ms-2">Cancel</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div> */}
        </div>
      </section>

      <Modal
        show={showInstModal}
        onHide={handleCloseInstModal}
        centered
        size="lg"
      >
        <Modal.Header>
          <Modal.Title> Institute Candidate Details</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseInstModal} />
        </Modal.Header>
        <Modal.Body className="settings jobapplication">
          <div className="container st3">
            <div className="row">
              <div className="col-lg-12">
                <div className="manage-search-bar">
                  <SearchIcon className="icon" />
                  <input
                    type="text"
                    placeholder="Search..."
                    className="manage-search-input Dark-Manage-Search"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="table-res">
                  <div className="react-dataTable">
                    <DataTable
                      noHeader
                      pagination
                      columns={Inscolumns}
                      paginationPerPage={7}
                      className="react-dataTable"
                      sortIcon={<ChevronDown size={10} />}
                      paginationDefaultPage={currentPage + 1}
                      data={InsCandidateList}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <button
            className="btn btn-danger apply-job me-2"
            onClick={handleCloseInfo}
          >
            Submit
          </button>
        </Modal.Footer> */}
      </Modal>

      <Modal show={showAcceptModal} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Re-schedule Meeting</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className="row">
            <div className="col-md-12 mt-2">
              <label htmlFor="about" className="f-14 f-700">
                Date
              </label>
              <Flatpickr
              // data-enable-time
              // value={date}
              // onChange={([date]) => {
              //     this.setState({ date });
              // }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="about" className="f-14 f-700">
                Time
              </label>
              <Flatpickr
                options={{
                  enableTime: true,
                  noCalendar: true,
                  dateFormat: "H:i", // Format for time only
                  time_24hr: true, // Optional: for 24-hour format
                }}
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="about" className="f-14 f-700">
                Time Duration
              </label>
              <input
                type="text"
                style={{ width: "100%" }}
              // value={contactNo}
              // onChange={(e) => setContactNo(e.target.value)}
              />
            </div>
            <div className="col-md-12 mt-2">
              <label htmlFor="about" className="f-14 f-700">
                Message
              </label>
              <textarea />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="khojPrimaryBtn1 ms-3 w-100">
            <Link to="/" className="">
              Re-schedule Meeting
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={showUserInfo} onHide={handleCloseInfo} centered size="md">
        <Modal.Header>
          <Modal.Title> Interview Details</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseInfo} />
        </Modal.Header>
        <Modal.Body className="settings">
          {/* <div className="mb-3">
                        <p>Are you sure you want to UnApply Job?</p>

                    </div> */}
          <Col md={12}>
            <div className="post-form-group d-flex flex-row">
              <label htmlFor="about">
                <div>{/* <h2>IMG</h2> */}</div>
              </label>
              <div className="px-2">
                <label htmlFor="schedule-time">
                  <h5>Ashh</h5>
                </label>
                <h6>FrontEnd Engineer</h6>
                <h6>React JS</h6>
              </div>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="schedule-time">
                Hiring Status :{" "}
                <span className="ms-2">{jobAppInfoData.hiringStatusName}</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Job Time:{" "}
                <span className="ms-2">{jobAppInfoData.typeName}</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Type: <span className="ms-2">{jobAppInfoData.rateType}</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Scheduled Time:{" "}
                <span className="ms-2">June 13 , 2024 , 05:30 am</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Remark: <span className="ms-2"></span>
              </label>
            </div>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger apply-job me-2"
            onClick={handleCloseInfo}
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAppliedModal} onHide={handleCloseModal} centered>
        <Modal.Header>
          <Modal.Title>Add Interview Schedule Details</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          {/* <div className="mb-3">
                        <p>Are you sure you want to UnApply Job?</p>

                    </div> */}
          <Col md={12}>
            {/* <div className="post-form-group">
              <label htmlFor="about">
                Schedule Time{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <input
                // type="text"
                // placeholder="Enter class name"
                type="datetime-local"
                value={scheduleTime}
                onChange={(e) => setScheduleTime(e.target.value)}
                placeholder="Enter schedule time"
                className="form-control  Dark-Input-from-group"
              />
            </div> */}
            <div className="post-form-group">
              <label htmlFor="about">
                Schedule Time{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <Flatpickr
                data-enable-time
                value={scheduleTime}
                onChange={(selectedDates) => {
                  setScheduleTime(selectedDates[0]);
                }}
                options={{
                  enableTime: true,
                  dateFormat: "Y-m-d H:i",
                }}
                className="form-control Dark-Input-from-group"
                placeholder="Enter schedule time"
              />
            </div>

          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="schedule-time">
                Interview Mode Type{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <select
                // id="schedule-time"
                // className="form-control"
                // placeholder="Select"
                id="place-type"
                value={placeType}
                onChange={(e) => setPlaceType(e.target.value)}
                className="form-control  Dark-Input-from-group"
              >
                <option value="0"> Select </option>
                <option value="1">OnSite</option>
                <option value="2">Remote</option>
                <option value="3">Hybrid</option>
              </select>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Place Details{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <input
                // type="text"
                // placeholder="Enter class name"
                type="text"
                value={placeDetails}
                onChange={(e) => setPlaceDetails(e.target.value)}
                placeholder="Enter place details"
                className="form-control  Dark-Input-from-group"
              />
            </div>
          </Col>

          <Col md={12}>
            <Form.Group controlId="description">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                // as="textarea"
                // rows={3}
                // placeholder="Enter Remark"
                as="textarea"
                rows={3}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter remark"
                className=" Dark-Input-from-group"
              />
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger apply-job me-2"
            //  onClick={handleCloseModal}
            onClick={ScheduleInterview}
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirmationModal} onHide={handleCancel} centered>
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCancel} />
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to do ?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => {
              if (applicationStatus === "Hired") {
                AcceptApplication(jobAppId, "Hired");
              } else if (applicationStatus === "Blocked") {
                AcceptApplication(jobAppId, "Blocked");
              } else if (applicationStatus === "Rejected") {
                AcceptApplication(jobAppId, "Rejected");
              }
              // handleDeleteRow(jobAppId);
              // handleCloseCancelModal();
            }}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showRemarkModal} onHide={handleCloseRemark} centered>
        <Modal.Header>
          <Modal.Title>Update Remark</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseRemark} />
        </Modal.Header>
        <Modal.Body> 
          <div className="row">
            <div className="col-md-12 mt-2">
              <label htmlFor="about" className="f-14 f-700">
                Remark
              </label>
              <input
                type="text"
                style={{ width: "100%" }}
                value={updateRemark}
                onChange={(e) => setUpdateRemark(e.target.value)}
              />
               {displays && ! updateRemark ? (
                    <span className="error_msg_lbl text-red">
                      Select Class{" "}
                    </span>
                  ) : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => {
              remarkUpdateFn();
            }}
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showInstConfirmationModal}
        onHide={handleInstituteCancel}
        centered
      >
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleInstituteCancel} />
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to do ?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => {
              if (applicationStatus === "Hired") {
                AcceptApplicationAsInst(jobAppId, "Hired");
              } else if (applicationStatus === "Blocked") {
                AcceptApplicationAsInst(jobAppId, "Blocked");
              } else if (applicationStatus === "Rejected") {
                AcceptApplicationAsInst(jobAppId, "Rejected");
              }
              // handleDeleteRow(jobAppId);
              // handleCloseCancelModal();
            }}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAppliedModalScheule}
        onHide={handleCloseModalScheule}
        centered
      >
        <Modal.Header>
          <Modal.Title>Add Interview Schedule Details</Modal.Title>
          <CloseSharpIcon
            className="pointer"
            onClick={handleCloseModalScheule}
          />
        </Modal.Header>
        <Modal.Body className="settings">
          {/* <div className="mb-3">
                        <p>Are you sure you want to UnApply Job?</p>

                    </div> */}
          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Schedule Time{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <Flatpickr
                data-enable-time
                value={scheduleTime}
                onChange={(selectedDates) => {
                  setScheduleTime(selectedDates[0]);
                }}
                options={{
                  enableTime: true,
                  dateFormat: "Y-m-d H:i",
                }}
                className="form-control Dark-Input-from-group"
                placeholder="Enter schedule time"
              />
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="schedule-time">
                Interview Mode Type{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <select
                // id="schedule-time"
                // className="form-control"
                // placeholder="Select"
                id="place-type"
                value={placeType}
                onChange={(e) => setPlaceType(e.target.value)}
                className="form-control Dark-Input-from-group"
              >
                <option value="0"> Select </option>
                <option value="1">OnSite</option>
                <option value="2">Remote</option>
                <option value="3">Hybrid</option>
              </select>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Place Details{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </label>
              <input
                // type="text"
                // placeholder="Enter class name"
                type="text"
                value={placeDetails}
                onChange={(e) => setPlaceDetails(e.target.value)}
                placeholder="Enter place details"
                className="form-control Dark-Input-from-group"
              />
            </div>
          </Col>

          <Col md={12}>
            <Form.Group controlId="description">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                // as="textarea"
                // rows={3}
                // placeholder="Enter Remark"
                as="textarea"
                rows={3}
                className="Dark-Input-from-group"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter remark"
              />
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger apply-job me-2"
            //  onClick={handleCloseModal}
            onClick={ScheduleInterviewAsInst}
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InterviewSchedule;
